var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShimmer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7685 3.23616C16.7809 -0.997834 10.2274 -1.08908 6.13098 3.0324C2.03457 7.15394 1.94631 13.9274 5.93394 18.1614L8.55547 15.5239C5.9838 12.7768 6.0458 8.39494 8.69776 5.72677C11.3497 3.05856 15.5893 3.11249 18.177 5.84354L20.7685 3.23616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.35413 20.7639C7.3417 24.9978 13.8951 25.089 17.9915 20.9675C22.0879 16.8461 22.1762 10.0726 18.1886 5.83862L15.5673 8.47593C18.139 11.2231 18.0771 15.6049 15.4251 18.2731C12.7731 20.9413 8.53352 20.8874 5.94583 18.1564L3.35413 20.7639Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShimmer);
export default __webpack_public_path__ + "static/media/shimmer.b83c3a662be67be65f3eb56799663c80.svg";
export { ForwardRef as ReactComponent };